import Head from 'next/head';

//#region [Component]
export default function KinotoppenSeo() {
	return <Head>
		<meta key="ogTitle" property="og:title" content="Kinotoppen" />

		<meta key="ogDescription" name="og:description" content="Se hvilke filmer som topper kinolistene i Norge. Oversikt over helgens mest sette og kinotoppen for i år." />
		<meta key="metaDescription" name="description" content="Se hvilke filmer som topper kinolistene i Norge. Oversikt over helgens mest sette og kinotoppen for i år."/>
		<meta key="metaTitle" name="title" content="Kinotoppen - Filmweb" />

		<title key="title">Kinotoppen - Filmweb</title>

	</Head>
}
//#endregion